export default "__VITE_ASSET__Dn70PvpS__"